<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="达播名称" prop="authorName">
            <el-select v-model="searchForm.authorName" clearable filterable multiple collapse-tags>
              <el-option v-for="item in categoryList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="handleEdit(null)">新增</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="authorName" label="达播名称" min-width="180"></el-table-column>
        <el-table-column prop="pricePeriod" label="控价周期" min-width="80"></el-table-column>
        <el-table-column prop="updatedBy" label="更新人" min-width="80"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" min-width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" class="red-text-btn" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <editDialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" @success="onSearch" />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import editDialog from './components/edit';
import axios from '@/utils/axiosInstance';

export default {
  name: 'ShippingCycleLimit',
  mixins: [tableMixin, pagePathMixin],
  components: {
    editDialog,
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      isShowEdit: false,
      all: false,
      searchFormData: [],
      rules: {},
      rowData: {},
      categoryList: [],
      searchForm: {
        authorName: '',
      },
    };
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.getOptionType();
      this.init();
    },
    async init() {
      this.loading = true;
      let { authorName } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: authorName ? authorName.join(',') : '',
      };
      this.searchFormData = data;
      this.$q.configurationCenter
        .authorPricePage({ data: data })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleEdit(row) {
      this.rowData = !row ? row : { ...row };
      this.isShowEdit = true;
    },

    handleDelete(row) {
      this.$confirm('是否确认删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$q.configurationCenter.deleteAuthorPrice({ fragment: [row.id] }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功');
            this.onSearch();
          }
        });
      });
    },
    getOptionType() {
      this.$q.configurationCenter.queryAuthorName().then(res => {
        this.categoryList = res.data;
      });
    },
  },

  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}
</style>
